import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomDropdownWithSelect } from '../DropDown/CustomDropdown';

const RoleTypeFilter = ({
    roleTypeList,
    selectedType,
    setSelectedType,
    handleClick,
    handleClose,
    anchorEl,
}) => {
    const { t } = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleButtonClick = (event) => {
        setIsDropdownOpen(true);
        handleClick('-1', event);
    };

    const handleDropdownClose = () => {
        setIsDropdownOpen(false);
        handleClose('-1');
    };

    return (
        <>
            <button
                aria-controls="customized-menu"
                aria-haspopup="true"
                onClick={handleButtonClick}
                style={{
                    padding: '4px',
                    border: 'none',

                    borderRadius: '6px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '20px',
                    height: '20px',
                    flexShrink: 0,
                }}
            >
                <img
                    src="/Images/icon-filter.png"
                    alt="filter"
                    style={{
                        width: '16px',
                        height: '16px',
                        display: 'block',
                        flexShrink: 0,
                        objectFit: 'contain',
                        filter: selectedType?.type?.length > 0 ? 'none' : 'grayscale(1)',
                    }}
                />
            </button>
            <CustomDropdownWithSelect
                value={selectedType}
                handleClose={handleDropdownClose}
                anchorEl={anchorEl && anchorEl['-1']}
                list={roleTypeList}
                setValue={(index) => setSelectedType(roleTypeList[index])}
                getOptionLabel={(option) => {
                    return t(option.text);
                }}
                open={isDropdownOpen}
                variant="gray"
            />
        </>
    );
};

export default RoleTypeFilter;
